module.exports = __webpack_public_path__ + "static/media/PATS_6-1267w.090c982d.webp";